import { Skeleton } from "@/shared/components/ui/skeleton";

export function VenueApprovalSkeleton() {
  return (
    <div data-testid="venue-queue-loading" className="space-y-3">
      {Array.from({ length: 3 }, (_, i) => (
        <div key={i} className="flex gap-4 rounded-lg border border-border/60 p-4">
          <Skeleton className="h-24 w-24 rounded-md" />
          <div className="flex flex-1 flex-col gap-2">
            <Skeleton className="h-5 w-2/3" />
            <Skeleton className="h-4 w-1/3" />
            <Skeleton className="h-4 w-1/4" />
          </div>
        </div>
      ))}
    </div>
  );
}
